import { func, string, bool, number } from 'prop-types'
import React, { useState } from 'react'
import './Imgloaded.css'
const ImgLoaded = (props) => {
  const [isLoaded, setIsLoaded] = useState(false)
  const {img, alt='', skeletonclass='', className='', width=null, sizes, stopProp, onClick} = props

  return ( 
  <>
    <div onClick={(e)=> {stopProp && e.stopPropagation(); onClick && onClick()}} className={`imgloaded ${className}`} style={{top: sizes?-sizes(50):null}}>
      <img onLoad={() => setIsLoaded(true)} src={img} alt={alt} style={isLoaded ? { display: 'block', width } : { display: 'none' }} />
      <div className={"rskeletonimg "+skeletonclass} style={!isLoaded?{display: 'block', width: sizes?sizes(100):null, height: sizes?sizes(100):null}:{display: 'none'}} aria-hidden="true"></div>
    </div> 
  </>
  )
} 
ImgLoaded.propTypes = {
    img: string,
    alt: string,
    skeletonclass: string,
    className: string,
    dimension: number,
    width: number,
    size: number,
    stopProp: bool,
    onClick: func
};

export default ImgLoaded